import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import BrieConversationAPI from "../../../api/api/BrieConversationAPI";
import { InvalidateGPTProjectQueries } from "./useCreateProject";
import { BrieGPTTabs } from "./BrieGPTSidebarElements/Types";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { Instruction } from "./useBrieGPTItems";

type ChatPayload = {
  data: {
    chatID: string;
    payload: {
      Name?: string;
      InstructionList?: Instruction[];
    };
  } & ({ type: "view"; viewID: string } | { type: "record"; recordID: string });
  onSuccess?: () => void;
  onError?: () => void;
};

export default function useUpdateGPTChats(
  projectID: string | undefined | null,
  tab: BrieGPTTabs | undefined
) {
  const client = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom) || "";

  const updateChat = useMutation({
    mutationFn: (payload: ChatPayload) => {
      return BrieConversationAPI.updateBrieGPTChat(payload.data);
    },
    onSuccess: (_, { data, onSuccess }) => {
      const queryIds = data.type === "view" ? [data.viewID] : [data.recordID];
      if (projectID && tab) {
        InvalidateGPTProjectQueries({
          tab,
          tenantID,
          itemID: queryIds[0],
          client,
        });
      } else {
        client.invalidateQueries({
          queryKey: [tenantID, ...queryIds, "BrieGPTChats"],
        });
      }

      onSuccess && onSuccess();
    },
    onError: (err, { onError }) => {
      onError && onError();
    },
  });

  return {
    updateChat: updateChat.mutate,
    updating: updateChat.isPending,
  };
}
